export default __webpack_public_path__ + "assets/e6a4254873c7aefb3975a55b0704e25d.jpg";